var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLimitedEdition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98389 11.4564L5.82275 14.677C5.78856 14.7718 5.72675 14.8536 5.64565 14.9114C5.56454 14.9692 5.46804 15.0001 5.36916 15.0001C5.27029 15.0001 5.17379 14.9692 5.09268 14.9114C5.01157 14.8536 4.94976 14.7718 4.91558 14.677L3.75443 11.4564C3.73025 11.3893 3.69212 11.3284 3.64266 11.2779C3.5932 11.2273 3.53359 11.1884 3.46796 11.1637L0.316277 9.97712C0.223497 9.94219 0.14343 9.87903 0.0868761 9.79615C0.0303218 9.71327 0 9.61466 0 9.51362C0 9.41259 0.0303218 9.31398 0.0868761 9.2311C0.14343 9.14822 0.223497 9.08506 0.316277 9.05013L3.46796 7.8636C3.53359 7.83889 3.5932 7.79992 3.64266 7.74938C3.69212 7.69884 3.73025 7.63793 3.75443 7.57086L4.91558 4.35029C4.94976 4.25548 5.01157 4.17367 5.09268 4.11587C5.17379 4.05808 5.27029 4.0271 5.36916 4.0271C5.46804 4.0271 5.56454 4.05808 5.64565 4.11587C5.72675 4.17367 5.78856 4.25548 5.82275 4.35029L6.98389 7.57086C7.00807 7.63793 7.04621 7.69884 7.09567 7.74938C7.14513 7.79992 7.20473 7.83889 7.27037 7.8636L10.422 9.05013C10.5148 9.08506 10.5949 9.14822 10.6515 9.2311C10.708 9.31398 10.7383 9.41259 10.7383 9.51362C10.7383 9.61466 10.708 9.71327 10.6515 9.79615C10.5949 9.87903 10.5148 9.94219 10.422 9.97712L7.27037 11.1637C7.20473 11.1884 7.14513 11.2273 7.09567 11.2779C7.04621 11.3284 7.00807 11.3893 6.98389 11.4564Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66455 1V5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8122 3.01221H7.51685",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8523 5V9",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 6.99988H11.7046",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitedEdition);
export default __webpack_public_path__ + "static/media/limited-edition.f634b923.svg";
export { ForwardRef as ReactComponent };